import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=deb0cf6a&scoped=true"
import script from "./SessionsList.vue?vue&type=script&lang=js"
export * from "./SessionsList.vue?vue&type=script&lang=js"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=deb0cf6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb0cf6a",
  null
  
)

export default component.exports